import { render, staticRenderFns } from "./ReminderWorkflowList.vue?vue&type=template&id=07d8eab7&scoped=true&"
import script from "./ReminderWorkflowList.vue?vue&type=script&lang=js&"
export * from "./ReminderWorkflowList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderWorkflowList.vue?vue&type=style&index=0&id=07d8eab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8eab7",
  null
  
)

component.options.__file = "ReminderWorkflowList.vue"
export default component.exports